import { Checkbox, VStack, RichText } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  isEmptyReport: boolean;
  setIsEmptyReport: (value: boolean) => void;
}

const ContinueReportModalBody: React.FC<Props> = ({
  isEmptyReport,
  setIsEmptyReport,
}) => {
  const { t } = useTranslation();

  return (
    <VStack spacing="4" align="stretch">
      <RichText
        value={`<div>${t(
          'ADVISORY-REPORTS_DETAIL_REVISION-MODAL_DESCRIPTION_1',
        )}</div>`}
        color="gray.500"
      />
      <RichText
        color="gray.500"
        value={`<div>${t(
          'ADVISORY-REPORTS_DETAIL_REVISION-MODAL_DESCRIPTION_2',
        )}</div>`}
      />
      <Checkbox
        isChecked={isEmptyReport}
        onChange={(e) => setIsEmptyReport(e.target.checked)}
      >
        {t('ADVISORY-REPORTS_DETAIL_REVISION-MODAL_EMPTY-REPORT')}
      </Checkbox>
    </VStack>
  );
};

export default ContinueReportModalBody;
